import getStore from 'services/getStore';
import { colors } from 'styles/variables';

const { lPink } = colors;

const checkButtonColors = props => {
  const {
    buttonBackgroundColor,
    buttonTextColor,
  } = getStore().getState().theme;

  const { localBackgroundColor, localColor } = props;

  // we preference in order :
  // props.background _ color set on button directly
  // buttonBackgroundColor _ color from them ( if any )
  // props.buttonBackground _ color from wizard ( if any )
  // default
  // sameness for textColor. . .

  // checked with ' localBackgroundColor, localColor ' which update to true when changed in settings
  // SINCE
  // where the fudge is the background from the ' section ' coming in here !!!!!
  //
  return {
    background:
      (localBackgroundColor && props.background) ||
      buttonBackgroundColor ||
      props.buttonBackground ||
      lPink,
    color:
      (localColor && props.color) ||
      buttonTextColor ||
      props.buttonForeground ||
      '#fff',
  };
};

export default checkButtonColors;
